const logProvider = {}

logProvider.init = () => {}

export default logProvider
